import useApi from "./useApiRequest";
import { useMutation } from "react-query";


export const EnviarOrden = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.put(`/administracion-inventario/salida/cerrar/documento/${params.data}?domicilio=${params.domicilio}`, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        enviarOrdenMutation: mutation.mutate,
    };
}